<template>
	<div id="leading-enterprises" class="oh">
		<headerbar :curindex="curindex" v-if="userdata.userType!=1"></headerbar>
		<div class="bluebanner" v-title :data-title="websitetype">
			<div class="centerpage1">
				<h2 class="title">创新企业招商</h2>
				<p></p>
			</div>
		</div>
		<leftnav class=" fl" :curindex="curindex" :isCollapse='isCollapse' :activenav='"1-4"' v-if="userdata.userType==1" ></leftnav>
		<!-- <span   @click="isCollapse = !isCollapse"  v-html="isCollapse?'>':'<'" class="nav_btn"> 展开</span> -->
		<div :class="userdata.userType ==1?'index_left2':'index_left'">
			<govheader v-if="userdata.userType==1"></govheader> 
			<div :class="userdata.userType ==1?'index_left_centerpage':'centerpage pagecontent'">   
			<div class="whitebox " > 
			<listMenu v-if="cityflag" :selectcitydata="selectcitydata" :searchtype="3" :total="total" :total1="total1" texts="新兴企业" :citymapdata="citymapdata" v-on:chartmapclick="chartmapclick" :notionlist="notionlist"   v-on:notionclickfun="notionclickfun" v-on:choosecityide="choosecityide"></listMenu>
				<div class="enterprise_list_box" v-show="enterpristlist.length != 0"> 
				<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" > 
					<tr>
						<th>企业名称</th>
						<th>所属行业</th>
						<th>画像标签</th> 
						<th>星级</th> 
						<th>融资轮次</th>
						<th>融资时间</th>
						<th>融资金额</th>
						<th>地区</th>
						<th>投资方</th>  
						</tr> 
					<tr v-for="list in enterpristlist">
						<td class="title"   @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</td>
						<td class="conpanytags hastag1" v-show="list.notion!=''">
								<span class="span-tag" v-for="item in list.notionlist"  @click="tagrouter('/enterpriseTag',3,'notion',item.id,item.name)">{{item.name}}</span> 
						</td> 
						<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
							<div class="" style="color: #999;">-</div>
						</td> 
						<td class="conpanytags hastag1" v-show="list.tag!=''"> 
								<span class="span-tag" v-for="item in list.taglist"  @click="tagrouter('/enterpriseTag',3,'tag',item.id,item.name)">{{item.name}}</span> 
						</td> 
						<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
							<div class="" style="color: #999;">-</div>
						</td> 
						<td>
							<p class="stargrade" v-if="typeof(list.star) == 'number' && list.star > 0 " >
								<img src="../../assets/starfull.png" alt="" v-for="item in list.star">
								<img src="../../assets/star.png" alt="" v-for="item in (5-list.star)">
							</p>
							<span v-if="list.star == 0">-</span>
						</td> 
						<td  v-html="list.financingRound.length>0?list.financingRound[0].rount:'-'"></td> 
						<td  v-html="list.financingRound.length>0?list.financingRound[0].time:'-'"></td> 
						<td  v-html="list.financingRound.length>0?list.financingRound[0].amount:'-'"></td>  
						<td>{{list.area}}</td>
						<td class="orglist" >
							<p v-if="list.financingRound.length>0"><span v-for="(org,inds) in list.financingRound[0].orgList" data="org.id" :class="org.id!=0?'curp':''" @click="routerlinkid('/investement-enterprises',org.id)">
							{{org.orgName}}<i v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span></p>
							<p v-if="list.financingRound.length==0">-</p>
							</td>  
					</tr>
				</table>
				</div> 
				<div class="centerpage1 company_pagelist" v-show="totalPage>1">
					<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total" 	v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
					</zpagenav>
				</div> 
		</div>
	</div>			
				
	</div>
		<footerbar v-if="userdata.userType!=1"></footerbar>
	</div>
</template>
 
<script>  
// import {PCC} from "../../assets/js/city.js";
import $ from "jquery";
	export default {
		name: 'innovtive-enterprises',
		data() {
			return {
				isCollapse:false,
			showscreen:false,
			notionslide:false,
			notionslide1:false,
			notionslide3:false,
			showmorecitydata:false,
			notioneditbtn:true,
			notioncodebtn:true,//第一次获取用户选择概念列表id
			citymapdata:[],
			cityflag:false,
			usernotionid:10,
			selectcitydata:[],
				notionlist:{},
				notionlist1:{},
				notionlist2:{},  
				flag:false, 
				usernotionlistsave:[],//用户选择的概念列表存储
				usernotionlist:[],//用户选择的概念列表
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				total1: 0, //记录总数
				totalPage:1,
				maxPage:10,  //最大页数
				provienceid:0,
				cityid:0,
				industryid:"", 
				enterpristlist:[],
				industrydata:[], 
				usertaglist:[],
				capitalid:0,
				typeid1:0, 
				num:1,  
				websitetype:"",
				curindex:3,
				userheadname:[
					{type:1,name:'创新企业招商',curindex:3},
					{type:2,name:'战略投资标的',curindex:2},
					{type:3,name:'同行企业库',curindex:5},
					{type:4,name:'投资标的推荐',curindex:2},
					{type:5,name:'新兴企业合作',curindex:3},
					],
			}
		},
		beforeCreate() {
			this.bus.$emit('loading', true);
		},
		created() {  
				this.$nextTick(() => {
				        // 禁用右键
				        document.oncontextmenu = new Function("event.returnValue=false");
				        // 禁用选择
				        document.onselectstart = new Function("event.returnValue=false");
				      }); 
		 var _this=this;  
			this.getuserinfor();  
			this.$axios.get(this.$api.cyl.notion.list()+'?level=4',{headers:{AuthToken:this.userdata.token}}).then(function(res){
				let arrts=[],attrd1={};
				if(res.data.success){   
				_this.notionlist=res.data.list == null ? []:res.data.list;      
					_this.cityflag=true;
				}else{ 
					
				} 
			}).catch(function (error) { 
				// 请求失败处理 console.log(error);
			}); 
		},
		mounted() { 
			document.getElementById('app').style.background = "#f0f3f5";
			var _this = this;
  this.ajaxsearchcompany(1);   
		},
		methods: {  
			//导航栏筛选
			notionclickfun(arry){
				this.usernotionlist=arry;
				this.usernotionlistsave=arry; 
				this.usernotionid=arry[0].id; 
				this.notioneditbtn=true;
				this.ajaxsearchcompany();
			},
			notionlistnumber(namelist,codelist){
				// console.log(namelist,codelist); 
				for(var i=0;i<namelist.length;i++){ 
				 let arry2=namelist[i].children;
					for(var d=0;d<namelist[i].children.length;d++){ 
						for(var s=0;s<codelist.length;s++){
							if(namelist[i].children[d].value  == codelist[s].code){
								namelist[i].children[d].count=codelist[s].count;
							}
						} 
						//二级
						// console.log('q',namelist[i].children[d].label);
						if(namelist[i].children[d].children!=null){
							for(var f=0;f<namelist[i].children[d].children.length;f++){
								for(var s=0;s<codelist.length;s++){
									if(namelist[i].children[d].children[f].value  == codelist[s].code){
										namelist[i].children[d].children[f].count=codelist[s].count;
									}
								}
								// console.log('f',namelist[i].children[d].children[f].label);
								if(namelist[i].children[d].children[f].children!=null){
										for(var g=0;g<namelist[i].children[d].children[f].children.length;g++){
											for(var s=0;s<codelist.length;s++){
												if(namelist[i].children[d].children[f].children[g].value  == codelist[s].code){
													namelist[i].children[d].children[f].children[g].count=codelist[s].count;
												}
											}
											// console.log('g',namelist[i].children[d].children[f].children[g].label); 
											//
										}  
								} 
								//
							}  
						}  
					 //
					} 
				};  
				this.notionlist=namelist;
			},
			choosecityide(art){ 
				// console.log(art);
				this.choosecityid(art[0],art[1]);
			},
			chartmapclick:function(data){ 
				var type="";
				if(data.data!=undefined && data.data.length>0){ 
					type=1;
				};
				this.choosecityid(data.id,type);
				this.notionslide3=false; 
			},   
			choosecityid(id,type){
					if(type == 1){
						this.provienceid=id;
						this.cityid=0;
					}else{
						this.provienceid=0;
						this.cityid=id;
					} 
					this.notioneditbtn=false;
					this.ajaxsearchcompany();
					this.notionslide1=false;
				},  
			//公用
			getuserinfor(){
				let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
				if(typeof(dataddd) == 'object'){
				this.userdata = dataddd;
				}else{
				this.userdata = JSON.parse(dataddd);
				} 
				// this.industryid=this.userdata.industry; 
				this.usertaglist=this.taglistfun(this.userdata.tagText,this.userdata.tag);
				this.usernotionlistsave=this.taglistfun(this.userdata.notionText,this.userdata.notion);
			 var _this=this;
			 this.userheadname.forEach((data)=>{
			 	if(data.type == _this.userdata.userType){
			 		_this.websitetype=data.name;
			 		_this.curindex=data.curindex; 
			 	} 
			 })
			},    
			pageHandler: function (page) {
				this.notioneditbtn=false;
				this.ajaxsearchcompany(page); 
			},  
			jsondouhao(name,data){
				var notionja="",douhao='%2C';
				if(data.length == 0){
					return notionja;
				}  
				for(var i=0;i<data.length;i++){ 
					if(i==data.length-1){
						douhao='';
					}
					notionja+=data[i].id+douhao;
				}
				notionja='&'+name+'='+notionja;
				return notionja; 
			},
				ajaxsearchcompany(pages){ 
				this.bus.$emit('loading',true);   
				var ajpage=1;
				if(pages){
					ajpage=pages;
				} 
				this.page=ajpage;
					var _this=this; 
					var notionja=_this.jsondouhao('notion',this.usernotionlistsave);  
					var tagaja=_this.jsondouhao('tag',this.usertaglist); 
					this.$axios.get(this.$api.cyl.enterprise.list()+'?type=2&city='+this.cityid+'&province='+this.provienceid+notionja+tagaja+'&page='+ajpage,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						console.log(res.data) ;
						if(res.data.success){  
									_this.enterpristlist=res.data.list;
									for(var i=0;i<res.data.list.length;i++){
										_this.enterpristlist[i].taglist=_this.taglistfun(_this.enterpristlist[i].tag,_this.enterpristlist[i].tagCode);
										_this.enterpristlist[i].notionlist=_this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode);  
										//创新企业专属 
										if(_this.enterpristlist[i].financingRound == null ){
											_this.enterpristlist[i].financingRound=[];
										} 
									} 
										_this.bus.$emit('loading',false); 
										_this.totalPage=res.data.totalPage; 
										_this.pageSize=res.data.pageSize; 
									_this.total=res.data.totalRecord;
										_this.shownoresults=false;  
										_this.haspage=res.data.list.length  == res.data.pageSize;
										//导航栏筛选
										var citylistd=[],citytest=res.data.cityList;
										for(var i=0;i<citytest.length;i++){
											let citylista ={}; 
											citylista.value=citytest[i].count;  
											citylista.id=citytest[i].id;  
											citylista.name=_this.citynameremove(citytest[i].name);  
											citylista.data=[];
											for(var p=0;p<citytest[i].children.length;p++){
												let citydtac={};
												citydtac.value=citytest[i].children[p].count;
												citydtac.id=citytest[i].children[p].id;
												citydtac.name=citytest[i].children[p].name;
												citylista.data.push(citydtac); 
											}
											citylistd.push(citylista); 
										};  
										// console.log(citylistd)
										if(_this.notioneditbtn){
											_this.selectcitydata=res.data.cityList;
											_this.citymapdata=citylistd; 
											_this.total1=res.data.totalRecord; 
											// console.log('citymapdata',citylistd);
										}   
										if(_this.notioncodebtn){
											_this.notioncodebtn=false; 
										 _this.notionlistnumber(_this.notionlist,res.data.extend.notionList);
										} 
						}else{ 
							
						} 
					}).catch(function (error) {}); 
				// console.log(datas);  
			}
		}
	}
</script>

<style type="text/css" scoped="scoped">
	@import "../../assets/css/zpageNav.css";
</style> 
